"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformPickupAddressTypeToString = transformPickupAddressTypeToString;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformPickupAddressTypeToString(type) {
    switch (type) {
        case legacy_enums_1.LocationAddressType.Airport:
            return "Airport";
        case legacy_enums_1.LocationAddressType.Port:
            return "Port";
        case legacy_enums_1.LocationAddressType.Venice:
            return "Venice";
        case legacy_enums_1.LocationAddressType.Dubrovnik:
            return "Dubrovnik";
        case legacy_enums_1.LocationAddressType.Incomplete:
            return "Incomplete";
        case legacy_enums_1.LocationAddressType.MeetingPosition:
            return "Meeting position";
        case legacy_enums_1.LocationAddressType.Train:
            return "Train";
        default:
            return "unknown type";
    }
}
//# sourceMappingURL=transformPickupAddressTypeToString.js.map